import React, { useMemo, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ThemeProvider } from '@mui/material/styles';

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import theme from '../../theme/theme';

interface PiPPortalProps {
  pipWindow: Window;
  children: React.ReactNode;
}

const PiPPortal: React.FC<PiPPortalProps> = ({ pipWindow, children }) => {
  const emotionCache = useMemo(
    () => createCache({ key: 'pip', container: pipWindow.document.head }),
    [pipWindow],
  );

  // Inject Google Fonts into the PiP window
  useEffect(() => {
    const doc = pipWindow.document;
    const fontLink = doc.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Lexend:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap';
    doc.head.appendChild(fontLink);
    return () => {
      try { doc.head.removeChild(fontLink); } catch (_) { /* window may be closed */ }
    };
  }, [pipWindow]);

  return createPortal(
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </CacheProvider>,
    pipWindow.document.body,
  );
};

export default PiPPortal;
